import * as R from 'ramda';

const deactivateSponsor = store => async (state, { rhId, sponsor }) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);
    const { placements } = rightsholders[rhIndex];

    const newPlacements = placements.map(pl => {
        const { sponsors } = pl;
        const newSponsors = sponsors.map(sp => {
            if (sp.id === sponsor.id) return { ...sponsor, ...sp };
            return sp;
        });

        return {
            ...pl,
            sponsors: newSponsors,
        };
    });

    const placementLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
    ]);

    store.setState(R.set(placementLens, newPlacements, store.getState()), true);
};

export default deactivateSponsor;
